export default __webpack_public_path__ + "static/media/intel-i7.953d581d.png";